import { api_GET, api_POST, api_PUT, api_DELETE, api_POST_Unauthorize } from "./_api.js";
import { getSessionCookie } from "../helpers/cookies.js";

const usuario_api = {
  authenticate: (json_submit) => {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate`, json_submit)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getList: () => {
    const session = getSessionCookie();
    const promise = new Promise((resolve, reject) => {
      api_GET(`usuario/getList/${session.acesso.modulo}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getListUsuariosIntegrador: () => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`usuario/GetListUsuariosIntegrador`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getListByPerfil: (perfil, setorId) => {
    const session = getSessionCookie();
    const promise = new Promise((resolve, reject) => {
      api_GET(`usuario/getListByPerfil/${perfil}/${setorId}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getItem: (id) => {
    const promise = new Promise((resolve, reject) => {
      api_GET("usuario/getItem/" + id)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getItemByCPFCNPJ: (cpfcnpj) => {
    const promise = new Promise((resolve, reject) => {
      api_GET("usuario/GetItemByCPFCNPJ/" + cpfcnpj)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  post: (model) => {
    const promise = new Promise((resolve, reject) => {
      api_POST("usuario", model)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  put: (model) => {
    const promise = new Promise((resolve, reject) => {
      api_PUT("usuario", model)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getFuncionalidades: (sigla = null) => {
    const session = getSessionCookie();
    const promise = new Promise((resolve, reject) => {
      api_GET(`usuario/getFuncionalidades/${sigla ? sigla : session.acesso.sigla}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  getPerfisCadastro: () => {
    const session = getSessionCookie();
    const promise = new Promise((resolve, reject) => {
      api_GET(`usuario/GetPerfisCadastro/${session.acesso.modulo}`)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });
    return promise;
  },
  trocar_senha: function (json_submit) {
    const promise = new Promise((resolve, reject) => {
      api_POST(`usuario/TrocarSenha`, json_submit)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });

    return promise;
  },
  recuperarsenha: function (email) {
    const promise = new Promise((resolve, reject) => {
      api_POST_Unauthorize(`authenticate/RecuperarSenha`, email)
        .then(result => resolve(result))
        .catch(result => reject(result));
    });

    return promise;
  },
  GetUsuarioPrefeitura: (tbUsuario_id) => {
    const promise = new Promise((resolve, reject) => {
      api_GET(`Usuario/GetUsuarioPrefeitura/${tbUsuario_id}`)
          .then(result => resolve(result))
          .catch(result => reject(result))
    });
    return promise;
  },
}

export default usuario_api;
